export default function Range(from, to, step = 1) {
  const result = [];
  const increasing = from <= to;
  if (increasing) {
    for (let i = from; i <= to; i += step) {
      result.push(i);
    }
  } else {
    for (let i = from; i >= to; i -= Math.abs(step)) {
      result.push(i);
    }
  }
  return result;
}
